import React, { useCallback, useState } from 'react';

import OverviewSidebar from './OverviewSidebar';
import CreateBoardModal from './CreateBoardModal';
import Boards from './Boards';
import OwnBoards from './OwnBoards';
import SharedBoards from './SharedBoards';
import Templates from './Templates';
import Header from './Header';

import './Overview.css';

const Overview = ({ activeView }) => {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const openCreateModal = useCallback(() => setIsCreateModalOpen(true), []);
  const closeCreateModal = useCallback(() => setIsCreateModalOpen(false), []);

  return (
    <>
      <Header />
      <div className="content-wrapper">
        <div className="Projects">
          <OverviewSidebar activeView={activeView} openCreateModal={openCreateModal} />
          {activeView === 'all' && <Boards openCreateModal={openCreateModal} />}
          {activeView === 'own' && <OwnBoards openCreateModal={openCreateModal} />}
          {activeView === 'shared' && <SharedBoards openCreateModal={openCreateModal} />}
          {activeView === 'templates' && <Templates openCreateModal={openCreateModal} />}

          <CreateBoardModal isOpen={isCreateModalOpen} onClose={closeCreateModal} />
          {/* <Modal open={this.state.isCreateModalOpen} onClose={this.closeCreateModal} closeIconSize={32} classNames={{modal: 'modal-bg', closeIcon: 'close-icon' }} center>
        <div className="p-2 d-flex">
          <div className="w-50">
            <label for="title"><h3>Add title to this circly board</h3></label>
            <input type="text" id="title" className="title input" />
          </div>
          <div className="w-50">
              <h3>Who can see this circly board?</h3>
              <div>
                <input type="radio" id="private" name="publicity" value="private" className="radio input mr-2" />
                <label for="private">Only people who I shared with</label>
              </div>
              <div>
                <input type="radio" id="anyone" name="drone" value="public" checked className="radio input mr-2" />
                <label for="public">Anyone on the web</label>
              </div>
          </div>
        </div>
      </Modal> */}
        </div>
      </div>
    </>
  );
};

export default Overview;
